export const LANGUAGE = {
  EN: 'en',
  ZH: 'zh',
  ZH_HANT_HK: 'zh-Hant-HK'
};
